/**
 * Combining all the NGI reducers here and exporting
 */
'use strict'

import {combineReducers, applyMiddleware } from 'redux'

import BasicSearchReducer from 'ECD/basic-device-search/BasicSearchReducer'; 

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');
import {  SET_CURRENT_PAGE, SET_CURRENT_USER }from 'Global/AppConstants';
import RDSReducer from 'RDS/store/RDSReducer';
import PowerBIReducer from 'PowerBI/store/PowerBIReducer';
import FileUploadReducer from 'FileUpload/store/FileUploadReducer';
import D2CTransferedFilesReducer from 'FileUpload/subfeatures/D2CTransferedFiles/TransferedFilesReducer';
import FileDownloadReducer from 'FileDownload/store/FileDownloadReducer';
import HomePageReducer from 'Home/store/HomePageReducer';
import AuthorizationReducer from 'Authorization/store/AuthorizationReducer';
import VersionNumberReducer from 'ECD/Version/FileVersionReducer';
import RSUReducer from 'Instrument/subfeatures/rsu/RSUReducer';
import InstrumentKPIReducer from 'InstrumentKPI/store/InstrumentKPIReducer'
import InstrumentUptimeReducer from 'Instrument/subfeatures/PerformanceMonitor/InstrumentUptime/InstrumentUptimeReducer';
import InstrumentConnectivityReducer from 'Instrument/subfeatures/PerformanceMonitor/InstrumentConnectivity/InstrumentConnectivityReducer';
import InstrumentTestsReducer from 'Instrument/subfeatures/PerformanceMonitor/InstrumentTests/InstrumentTestsReducer';
import UserPreferenceSettingReducer from 'UserManagement/store/UserPreferenceSettingReducer';
import MetricpageReducer from 'Metrics/store/MetricpageReducer';
import RSUMODReducer from 'RSUModule/store/RSUMODReducer';
import allowedFeaturesReducer from 'ECD/allowed-features/allowedFeaturesReducer';
import RSUJOBStatusReducer from 'RSUModule/subfeatures/instrument-status/RSUJOBInstrumentStatusReducer';
import BannerReducer from 'Admin/subfeatures/Banner/BannerReducer';
import CertGenReducer from 'Admin/subfeatures/CertGen/CertGenReducer';
import AdminPageReducer from 'Admin/store/AdminPageReducer';
import DrillThroughReducer from 'DrillThrough/store/DrillThroughReducer';
import SystemReducer from 'Instrument/subfeatures/System/SystemReducer';
import IncidentsReducer from 'Instrument/subfeatures/Incidents/IncidentsReducer';
import CalAssaySummReducer from 'Instrument/subfeatures/CalibrationAssaySummary/CalAssaySummReducer';
import CalHistoryReducer from 'Instrument/subfeatures/Calibration/CalHistory/CalHistoryReducer';
import RBHistoryReducer from 'Instrument/subfeatures/ReagentBlank/ReagentHistory/RBHistoryReducer';
import QCAssaySummReducer from 'Instrument/subfeatures/QCAssaySummary/QCAssaySummReducer';
import EnrollmentStateReducer from 'Admin/subfeatures/AdminUnenrollment/AdminUnenrollmentReducer';
import CalibrationReducer from 'Instrument/subfeatures/Calibration/CalibrationReducer';
import UserGroupManagementReducer from 'Admin/subfeatures/User Group Management/UserGroupManagementReducer';
import InstrumentGroupManagementReducer from 'Admin/subfeatures/InstrumentGroupManagement/InstrumentGroupManagementReducer';
import UnassignedInstrumentsReducer from 'Admin/subfeatures/UnassignedInstruments/UnassignedInstrumentsReducer';
import AdminControlUserMgmtReducer from 'Admin/subfeatures/AdminControlUserMgmt/AdminControlUserMgmtReducer';
import AdminControlPowerBIReducer from 'Admin/subfeatures/AdminControlPowerBI/AdminControlPowerBIReducer'
import MessageFreqReducer from 'Instrument/subfeatures/MessageFreqMode/MessageFreqReducer';
import MeteringViewDataCountReducer from 'Metering/subfeatures/MeteringView/MeteringViewReducer';
import MeteringUploadReducer from 'Metering/subfeatures/MeteringUpload/MeteringUploadReducer';
import InstrumentModelOnboardConfigReducer from 'Admin/subfeatures/InstrumentModelOnboardConfig/InstrumentModelOnboardConfigReducer'
import SampleStatsReducer from 'Instrument/subfeatures/SampleStatistics/SampleStatisticsReducer'
import WatchlistReducer from 'Watchlist/store/WatchlistReducer';
import userSearchHistoryReducer from 'UserSearchHistory/store/UserSearchHistoryReducer';
import SiteViewReducer from 'SiteView/store/SiteViewReducer';
import TriggersReducer from 'Triggers/store/TriggersReducer';
import OfflineTriggerReducer from 'Triggers/store/OfflineTriggerReducer';
import DiagnosticsDataReducer from 'Instrument/subfeatures/DiagnosticsData/DiagnosticsDataReducer';
import InstrumentDataReducer from 'Instrument/store/InstrumentDataReducer';
import PowerBiEmbedConfigReducer from 'PowerBI/store/PowerBiEmbedConfigReducer';
import RBReducer from 'Instrument/subfeatures/ReagentBlank/RBReducer';
import RBReportReducer from 'Instrument/subfeatures/ReagentBlank/ReagentBlankReport/RBReportReducer';
import ISECalibrationReducer from 'Instrument/subfeatures/ISECalibration/ISECalibrationReducer';
import ChemCalReportReducer from 'Instrument/subfeatures/ChemCalibration/ChemCalReportReducer';
import LegacyCalReportReducer from 'Instrument/subfeatures/Calibration/LegacyCalReportReducer';
import RSUSoftwareListReducer from 'RSUModule/subfeatures/software-list/RSUSoftwareListReducer';
import RSUSoftwareUploadReducer from 'RSUModule/subfeatures/software-upload/RSUSoftwareUploadReducer';
import RMReducer from 'Instrument/subfeatures/ReactionMonitor/RMReducer';
import RAPBoxManagementReducer from 'Admin/subfeatures/RAPBoxManagement/RAPBoxManagementReducer';
import RulesReducer from 'Instrument/subfeatures/TriggerRules/RulesReducer';
import RemoteExecutionReducer from 'Admin/subfeatures/RAPBoxManagement/RemoteExecution/RemoteExecutionReducer';
import DXHReducer from 'Instrument/subfeatures/Glance/GlanceReducer';
import ConfigurationsTransferReducer from 'Admin/subfeatures/ConfigurationsTransfer/ConfigurationsTransferReducer';

// The initial application state
const initialState = {
    currentPage : '',
    currentUser : ''
};

export default combineReducers({
    BasicSearchReducer,
    RDSReducer,
    PowerBIReducer,
    FileUploadReducer,
    D2CTransferedFilesReducer,
    FileDownloadReducer,
    HomePageReducer,
    VersionNumberReducer,
    AuthorizationReducer,
    RSUReducer,
    InstrumentUptimeReducer,
    InstrumentKPIReducer,
    InstrumentConnectivityReducer,
    InstrumentTestsReducer,
    UserPreferenceSettingReducer,
    MetricpageReducer,
    BannerReducer,
    CertGenReducer,
    AdminPageReducer,
    RSUMODReducer,
    allowedFeaturesReducer,
    RSUJOBStatusReducer,
    DrillThroughReducer,
    SystemReducer,
    IncidentsReducer,
    CalAssaySummReducer,
    QCAssaySummReducer,
    EnrollmentStateReducer,
    CalibrationReducer,
    UserGroupManagementReducer,
    InstrumentGroupManagementReducer,
    UnassignedInstrumentsReducer,
    AdminControlUserMgmtReducer,
    AdminControlPowerBIReducer,
    MessageFreqReducer,
    MeteringViewDataCountReducer,
    MeteringUploadReducer,
    InstrumentModelOnboardConfigReducer,
    SampleStatsReducer,
    WatchlistReducer,
    DiagnosticsDataReducer,
    userSearchHistoryReducer,
    SiteViewReducer,
    TriggersReducer,
    OfflineTriggerReducer,
    InstrumentDataReducer,
    PowerBiEmbedConfigReducer,
    RBReducer,
    RBReportReducer,
    CalHistoryReducer,
    RBHistoryReducer,
    ISECalibrationReducer,
    ChemCalReportReducer,
    LegacyCalReportReducer,
    RSUSoftwareListReducer,
    RSUSoftwareUploadReducer,
    RMReducer,
    RulesReducer,
    RemoteExecutionReducer,
    RAPBoxManagementReducer,
    DXHReducer,
    ConfigurationsTransferReducer
});